import React, { useReducer } from 'react'
import { getUserData } from '../../services/common.services';
import GlobalReducers from './globalReducers';
import colors from '../../utils/styles/colors'

export const GlobalContext = React.createContext();
const initialState = {
    count: 0,
    loader: false,
    collection_sort: "-created",
    structures: {},
    alert: { status: false, message: '', severity: 'warning' },
    mark_as_ready: '',
    collection: {},
    req_detail_index: { sec: null, sub_sec: null, req: null },
    show_req_detail: false,
    single_collection: {},
    all_collections: [],
    tab_value: '',
    req_detail_tab: 0,
    expand_all: false,
    userData: getUserData(),
    sidebar_toggle: false,
    primary_main: colors.PRIMARY_GREEN,
    primary_light: colors.RED,
    secondary_main: colors.GREY,
    secondary_light: colors.RED,
    req_id: ''
}
function GlobalProvider({ children }) {
    const [state, dispatch] = useReducer(GlobalReducers, initialState)
    return (
        <GlobalContext.Provider value={{ globalState: state, globalDispatch: dispatch }}>
            {children}
        </GlobalContext.Provider>
    )
}
export default GlobalProvider
